export const HomePageTextLoopArr = [
  'sad', 'happy', 'excited', 'anxious', 'angry', 'confused', 'afraid', 'surprised', 'betrayed', 'appreciative'
]

export const PostPreviewIgnoreNames = [
  'likeButton', 'optionsButton', 'editPostButton', 'deletePostButton', 'cancelEditPost', 'submitEditPost', 'editPostTextarea', 'editPostBox'
]